import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2 as DocumentNumberRange,
  FormField
} from '@/components/custom/erp';

import { Label } from '@/components/ui/label';

const BasicInfoTab = () => {
  return (
    <div className='space-y-2 p-4'>
      {/* Date Range Fields */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Ngày nhập từ/đến</Label>
        <div>
          <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
        </div>
      </div>

      {/* Số chứng từ từ/đến */}
      <div className='flex items-center'>
        <DocumentNumberRange fromName='so_ct1' toName='so_ct2' labelClassName='w-40' />
      </div>

      {/* Loại dữ liệu */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Loại dữ liệu</Label>
        <div className='w-44'>
          <FormField
            name='loai_du_lieu'
            type='select'
            options={[
              { value: '1', label: 'Hàng hoá' },
              { value: '5', label: 'Dịch vụ' },
              { value: '6', label: 'Hàng hoá & dịch vụ' }
            ]}
            className='w-full'
          />
        </div>
        <div className='ml-24'>
          <FormField name='tl_yn' type='checkbox' label='Bao gồm trả lại' labelClassName='w-40 min-w-40 text-left' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
